import { PropsWithChildren, useEffect } from 'react';

import { useCheckVerificationsComplete } from 'hooks/useCheckVerificationsComplete';
import { checkIsBlockedAssets, useGetCheckIsBlockedAssets } from 'services/hooks/checkBlockedAssets';
import { openModal, useModalStackStore } from 'store/modalStackStore';

import ErrorBoundary from 'components/errorBoundary/ErrorBoundary';
import GeneralErrorBoundaryUI from 'components/errorBoundary/GeneralErrorBoundaryUI';
import AlertBlockedAssetsModal from 'components/modal/AlertBlockedAssetsModal';

// 블락된 에셋이 생긴 경우, 1회성 모달을 노출시키기 위한 Provider
export default function CheckBlockedAssetsProvider({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary fallbackComponent={GeneralErrorBoundaryUI}>
      <CheckBlockedAssets>{children}</CheckBlockedAssets>
    </ErrorBoundary>
  );
}

function CheckBlockedAssets({ children }: PropsWithChildren) {
  const { isAllVerificationCompleted } = useCheckVerificationsComplete();
  const { checkIsModalOpenByModalName } = useModalStackStore();

  const { data } = useGetCheckIsBlockedAssets();

  useEffect(() => {
    // 1회만 노출되도록
    const isNotAlertBlockedAssetsModalOpen = !checkIsModalOpenByModalName(AlertBlockedAssetsModal.name);

    // 한 번도 열리지 않았고, 모든 인증을 완료하고, 블록을 당하고, 열린 상태가 아니면 모달을 노출 (최초 모달을 열고나면 서버에서는 false 상태로 변경됨)
    if (isAllVerificationCompleted && isNotAlertBlockedAssetsModalOpen && data && checkIsBlockedAssets(data)) {
      openModal(<AlertBlockedAssetsModal />, {
        closeOnBackdropClick: false,
        modalWrapperStyle: {
          maxWidth: '330px',
        },
      });
    }
  }, [isAllVerificationCompleted, data]);

  return <>{children}</>;
}
